<template>
<!-- Payment Modal -->
<div v-if="!isLoading && hasLoaded" :class="id_name" class="modal  mtn show open" tabindex="0" style="z-index: 1003; display: block; opacity: 1; top: 4%; transform: scaleX(1) scaleY(1); min-height:350px; position: absolute; margin-bottom:10%">

    <a v-if="show_close" id="closemodal" @click.prevent="showClose">
        <img src="/mtn/assets/close.png" alt="close" />
    </a>

    <div class="modal-content" :class="modal_content_css">
        <!-- Back Button -->
        <a v-if="show_back" id="back" @click.prevent="globalBack">
            <span class="back">
                <img src="/mtn/assets/back.svg" alt="back">
            </span>
        </a>

        <!-- Title -->
        <!-- <h4 :class="in_view && in_view.toLowerCase() != 'status' && in_view && in_view.toLowerCase() != 'paymentoptions'  ? 'head-title' : null" v-html="title"></h4> -->

        <h4 :class="show_back ? 'head-title' : null" class="" v-html="title"></h4>

        <!-- Content-->
        <transition mode="out-in" name="fade">
            <component v-if="in_view" :is="in_view" :payload="payload" :appColor="appColor" :data="channelDetails" :client_info="client_info" :button_color="button_color" :channel="chosenChannel" @hideBack="handleBack" @handleTitle="handleTitle" @handleId="handleId" @handleCss="handleCss">
                <!-- AMOUNT SLOT -->
                <template v-slot:amount>
                    <p class="tot-text">Total</p>
                    <!-- ₦-->
                    <p class="tot-amount">₦{{payload.transaction.amount/100}}</p>
                </template>
            </component>

            <div class="mt-5" v-else>
                <Spinner :top_margin="false">Loading...</Spinner>
            </div>
        </transition>
    </div>
</div>
<!-- / Payment Modal -->
</template>

<script>
/* eslint-disable */
// var isIframe = window.parent.location !== window.location,

var win = window.parent;
var check = window.location.hostname;


// console.log(self.location)
// console.log(top.location)

const Status = () => import('./Status.vue')
import CardPayment from './CardPayment.vue'
import Cancel from './Cancel.vue'
import ComingSoon from './ComingSoon.vue'
import Transfer from './Transfer.vue'
import Spinner from './includes/Spinner.vue'
import Pin from './Pin.vue'
import NoProvider from './NoProvider.vue'
import OTP from './Otp.vue'
import axios from 'axios';
import PaymentOptions from './PaymentOptions.vue';
import RedirectQuery from './RedirectQuery.vue';
import Airtime from './Airtime.vue'; // Airtime, Wallet, Bank.Account
import Redirect from './Redirect.vue'; // Masterpass, verve, visa
import {
    EventBus
} from './includes/bus.js'; // Masterpass, verve, visa

export default {
    name: 'MTNPopup',
    components: {
        NoProvider,
        Cancel,
        CardPayment,
        ComingSoon,
        Transfer,
        Pin,
        OTP,
        Status,
        PaymentOptions,
        Airtime,
        Redirect,
        Spinner,
        RedirectQuery
    },
    watch: {
        in_view(val) {
            // console.log(val);
            if (val) {

                if (['status', 'paymentoptions', 'cancel'].includes(val.toLowerCase())) {
                    this.show_back = false;
                } else {
                    this.show_back = true;
                }

                if (['status', 'cancel'].includes(val.toLowerCase())) {
                    this.show_close = false;
                } else {
                    this.show_close = true;
                }
            }
        },

        show_back(val){
          // Hide if it's just only one option
          if(this.$store.state.channels.length ===1){
              if(document.getElementById('back'))
                document.getElementById('back').style.display = 'none';
                this.show_back = false;
          }
        },
        
        payload(newVal) {
            this.payload = newVal;
            if (!this.is_redirect) {
                if (!this.$store.state.isFailed) {
                    if (this.isReloadCall)
                        newVal.request_ref = this.$generateRequestRef();
                    let ref = newVal.transaction.transaction_ref + '_opt';
                    this.$store.dispatch('optionsTransRef', ref);
                    newVal.transaction.transaction_ref = ref;
                    this.paymentOptions(newVal)
                }
            }

        },
        channels(newVal) {
            this.channels = newVal;
        },
        /* isLoading(newVal) {
            this.isLoading = newVal;
        }, */
        channelDetails(newVal) {
            this.channelDetails = newVal;
        },
        hasLoaded(newVal) {
            this.hasLoaded = newVal;
        },
    },
    destroyed() {

    },

    mounted() {

        if (check.includes('.dev.') || check.includes('localhost')) {
            this.env = 'Dev';
            this.hasEnv = true;
        } else if (check.includes('.staging.')) {
            this.env = 'Staging';
            this.hasEnv = true;
        }

        EventBus.$on('changeComponent', payload => {
            let view=payload,
                data=null;
            if(typeof payload === 'object'){
                view = payload.view
                data = payload.data
            }
            
            this.changeComponent(view, data)
        });

    },

    created() {

        this.source = window.location.hostname.split('.')[0].toLowerCase();
        this.isIframe = window.isIframe;

        window.addEventListener('message', (event) => {
            try {

                let payload;

                if (event.data.path == "newTransaction" && event.data.type == "inline:url") {
                    payload = this.deepClone(event.data.params);
                    // Default View
                    if(Object.keys(payload.transaction).includes('options')  && payload.transaction.options !== null){
                        if (Object.keys(payload.transaction.options).includes('default_view')) {
                            if (payload.transaction.options.default_view.option && payload.transaction.options.default_view.provider)
                                this.$store.dispatch('showDefaultView', true);
                        }
                    }

                    this.$store.dispatch('payload', event.data.params);
                    this.$store.dispatch('api_key', payload.api_key);
                    this.$store.dispatch('transRef', payload.transaction.transaction_ref);
                    this.$store.dispatch('parentTransRef', payload.transaction.transaction_ref);
                    this.$store.dispatch('optionsTransRef', payload.transaction.transaction_ref);
                    this.$store.dispatch('popupReferrer', payload.transaction.meta.referrer);

                    delete payload.hasTLSFallback;
                    this.payload = payload

                    // this.hasAutoClose();

                } else if (event.data.path == "replyPopupFromIframe" && event.data.type == "ui:redirect") {
                    this.hasLoaded = true;
                    let returnPayload = event.data.params;
                    
                    // This works only for MasterPass
                    let redirectData = {
                        iframereply: {
                            message: returnPayload.message || null,
                            data: returnPayload.data || null,
                            provider: returnPayload.initialPayload ? returnPayload.initialPayload.provider : null,
                            redirect_content: returnPayload.initialPayload.redirect_content || null
                        },
                        source: 'iframeReply',
                        channels: this.channels,
                        paymentMethod: this.channels[this.$store.state.paymentMethodIndex],
                        paymentMethodProvider: this.$store.state.paymentMethodProvider,
                        index: this.$store.state.paymentMethodIndex,
                        transaction: returnPayload.initialPayload.transaction
                    }

                    if(returnPayload.initialPayload.provider.provider.toLowerCase() !== 'mpgs'){
                        this.changeComponent("RedirectQuery", redirectData, 'paywith', redirectData.iframereply.provider.option);
                    }else{
                        this.changeComponent("CardPayment", redirectData);
                    }

                } else if (event.data.path == "replyPopupFromIframe" && event.data.type == "ui:redirect-close") {
                    this.tryAgainAction(false);
                } else {
                    // console.log("some random event");
                    // console.log(event.data);
                }
            } catch (err) {
                console.log(err)
            }
        }, false);

        if (isIframe) {
            this.isIframe = true;
            this.handleTryAgainData();
        }



        
    },
    data() {
        return {
            in_view: '',
            modal_content_css: null,
            title: 'Pay with',
            id_name: "paywith",
            show_back: false,
            show_close: false,
            channelDetails: {},
            customer: {},
            hasLoaded: false,
            isIframe: false,
            isIframe: '',
            isCardActive: false,
            isTransferActive: false,
            isMTN: false,
            modalBackground: '',
            appColor: '',
            logoUrl: '',
            textColor: '',
            activeOption: '',
            optionsList: '',
            paymentChannels: {},
            isLoading: false,
            channels: {},
            payload: {},
            providerText: '',
            options: {},
            showStatus: false,
            env: "",
            hasEnv: false,
            isReloadCall: false,
            chosenChannel: "",
            client_info: {},
            button_color: {},
            idleTimeOut: '',
            template: 'default',
            title_prefix: '',
        }
    },
    methods: {
        showClose() {
            this.in_view = "Cancel";
            this.title = null;
        },

        handleBack(val) {
            // this.show_back = !this.show_back;
            this.show_back = val;
        },

        handleTitle(val) {
            this.title = val;
        },
        handleId(val) {
            this.id_name = val;
        },

        handleCss(val) {
            this.modal_content_css = val;
        },

        handleTryAgainData() {
            // Check to see if values are still present tryAgainAction
            if (this.$store.state.payload && this.$store.state.isFailed) { // Try Again Button here
                const newRef = `${this.$store.state.parentTransRef}-${this.$generateTransactionRef(4)}`; 
                this.$store.dispatch('transRef', newRef);
                this.$store.dispatch('isFailed', true);

                
                this.tryAgainAction(true);
                this.hasLoaded = true;
            } else if (this.payload.api_key != undefined && !this.$store.state.isFailed) {
                let payload = this.payload;
                // console.log(payload);
                this.paymentOptions(this.payload);
            } /* else {
                console.log("is nothing")
            } */
        },

        idleCheck() {
            if (this.hasLoaded) {
                this.idleTimeOut = setTimeout(() => {
                    console.log("Idle timeout monitoring started");
                    this.timeout();
                }, 10000);

                let vm = this;

                window.addEventListener("click", () => {
                    console.log("One click just occured, timeout increased for another 10 seconds");
                    if (this.idleTimeOut > 0) {
                        console.log("remove old timeout id" + this.idleTimeOut)
                        clearInterval(this.idleTimeOut);
                    }

                    this.idleTimeOut = setTimeout(() => {
                        console.log("New idle timeout monitoring started");
                        vm.timeout();
                    }, 10000);

                    console.log("New/Update timeout id" + this.idleTimeOut)
                });

            } else {
                console.log("Waiting for popup to be triggered");
            }
        },

        timeout() {
            // console.log("You session has expired");
            if (this.idleTimeOut > 0) {
                clearInterval(this.idleTimeOut);
                console.log(this.idleTimeOut);
                this.$router.replace('/v2/timeout');
            }
        },

        globalBack() {
            EventBus.$emit('global-back', {
                in_view: this.in_view || 'PaymentOptions',
                title: this.title,
                action: 'back',
            });
        },

        tryAgainAction(status = true) {
            try {

                if(!status){
                    //this.$store.dispatch('transRef', this.$generateTransactionRef(4));
                    const newRef = `${this.$store.state.parentTransRef}-${this.$generateTransactionRef(4)}`; 
                    this.$store.dispatch('transRef', newRef);
                }

                this.channels = this.paymentChannels = this.$store.state.options
                this.channels = this.channelDetails.channels = this.$store.state.options;

                let client_info = null
                client_info = this.client_info = this.$store.state.client_info;
                this.button_color = {
                    background: client_info.colors.primary_button || client_info.colors.app,
                    color: client_info.colors.payment_description ? client_info.colors.payment_description + '!important' : ''
                }

                this.providerText = client_info.footer_text;
                this.modalBackground = client_info.colors.modal_background + ' !important';
                this.appColor = client_info.colors.primary_button + ' !important';

                if (status)
                    this.payload = this.$store.state.payload

                this.isLoading = false;
                this.channelDetails.channels = this.paymentChannels
                this.changeComponent("PaymentOptions")
            } catch (err) {
                console.log(err)
            }
        },

        reload() {
            this.in_view = "";
            this.hasLoaded = false;

            let initialPayload = this.$store.state.payload,
                payload = this.deepClone(initialPayload);

            let ref = this.$generateTransactionRef();
            this.$store.dispatch('optionsTransRef', ref);
            payload.request_ref = ref + '_opt_rt';
            payload.transaction.transaction_ref = ref;
            this.isReloadCall = true;
            this.paymentOptions(payload);
        },

        getInitialPayload() {
            let p = this.$store.state.payload
            delete p.hasTLSFallback
            delete p.referrer
            delete p.mode

            return p;
        },

        paymentOptions(data) {
            let data2 = {
                endpoint: 'options',
                api_key: this.$store.state.api_key,
                payload: data
            }

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                "data": this.$generateToken(data2)
            }, {
                timeout: this.API_CALL_TIMEOUT, // 3 mins
                headers: {
                    Authorization: `Bearer ${this.$store.state.payload.api_key}`
                }
            }).then( ({ data}) => {

                try {

                    let hash = data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message,
                        responseData = res.data;

                     window.raw = JSON.stringify(res);

                        if (!["successful", "processing", "optionsdelivered"].includes(status)) {
                                window.failedFromStartMessage = message || "An error occured, please try again or contact the webmaster hussien@onepipe.io.";
                                window.failedFromStart = true;
                                this.$router.push('/v2/mtn/warning');
                                return;
                        }
                        // Check if preferred payment methods sent in the payload
                        let payloadTransaction = this.$store.state.payload.transaction
                        if (payloadTransaction)
                            if (payloadTransaction.options != null && Object.keys(payloadTransaction.options).includes("payment_options")) { // Don't forget to validate this from the Inline Js
                                responseData.options = this.preferredPaymentOptions(payloadTransaction.options.payment_options, responseData.options);
                            }

                        // Remove other options and append it as last item
                        let otherOptions = responseData.options.find( (x) =>  ['other options','other payment options'].includes(x.title.toLowerCase()));

                        // Append Other Options as always the last item.
                        responseData.options = responseData.options.filter( (x) => !(['other options','other payment options', 'other'].includes(x.title.toLowerCase())));

                        if(otherOptions !== undefined){
                            responseData.options.push(otherOptions);
                        }
                        

                        this.hasLoaded = true;
                        this.channels = this.paymentChannels = responseData.options;
                        this.channelDetails.channels = this.paymentChannels;

                        this.$store.dispatch('options', responseData.options);
                        this.$store.dispatch('channels', this.paymentChannels);
                        this.$store.dispatch('client_info', responseData.client_info);

                        if(this.paymentChannels.length ===1 && document.getElementById('back')) {
                            document.getElementById('back').style.display = 'none';
                            this.show_back = false;
                        }

                        this.client_info = responseData.client_info;
                        let client_info = responseData.client_info;
                        this.button_color = {
                            background: client_info.colors.primary_button || client_info.colors.app,
                            color: client_info.colors.payment_description ? client_info.colors.payment_description + '!important' : ''
                        }

                        this.providerText = responseData.client_info.footer_text;
                        this.modalBackground = responseData.client_info.colors.modal_background + ' !important';
                        this.appColor = responseData.client_info.colors.primary_button + ' !important';
                        // this.logo = responseData.client_info.image_url;

                        this.isLoading = false;
                        this.in_view = "PaymentOptions";

                        //  Begin tracking idle moments
                        // this.idleCheck();
                        
                    
                } catch (err) {
                    console.log(err);
                }
            }).catch(error => {
                console.log(error);
                window.failedFromStart = true;
                window.failedFromStartMessage = error
                window.raw = JSON.stringify(error);
                this.$router.push('/v2/mtn/warning');
            });

        },

        changeComponent(name, data = null, id_name = "paywith", title = "") {            
            if (this.in_view == 'Status')
                return;

            if (id_name !== null)
                this.id_name = id_name;

            if (title || (data !== null && data.title !== null))
                this.title = title || data.title;

            if (this.is_redirect) {
                this.title = title || data.iframereply.provider.option;
            }

            if (data != null)
                this.channelDetails.details = data;

            this.in_view = name;

        },

        updateComponent(key) {
            // console.log(key)
            if (this.in_view == 'Status')
                return;
            this.channelDetails.details = this.channels[key]

            this.$store.dispatch('paymentMethod', this.channelDetails.option)
            this.selectComponent(this.channels[key].auth_type, key)
        },

        selectComponent(method, index) {
            let data = this.channels[index],
                in_view=null;

            switch (method.toLowerCase()) {
                case "airtime":
                case "wallet":
                case "bank.account":
                    in_view = "Airtime";
                    break;

                case "voucher":
                    in_view = "Voucher";
                    break;

                case "bank.transfer":
                case "cash":
                    this.in_view = "Transfer";
                    break;

                case "masterpass":
                case "ipg":
                    in_view = "Redirect";
                    break;

                case "card":
                default:
                    in_view = "CardPayment";
            }

            this.changeComponent(in_view, data);
        },

        deepClone(obj) {
            return JSON.parse(JSON.stringify(obj));
        },

        closeIframe() {
            
            this.changeComponent('PaymentOptions');

            this.isLoading = true;
            this.hasLoaded = false;
            this.in_view = 'PaymentOptions';
            let referrer = this.$store.state.popupReferrer

            this.$store.replaceState({
                paymentMethod: '',
                paymentMethodIndex: '',
                client_info: {},
                payload: {},
                service_call_payload: {},
                options: {},
                api_key: null,
                isFailed: false,
                hasPaid: false,
                hasOtp: false,
                isLoading: true,
                channels: {},
                popupReferrer: null,
                provider: {},
                card_cc: '',
                card_exp: '',
                card_cvv: '',
                parentTransRef: '',
                optionsTransRef: '',
                showDefaultView: false,
                transRef: '',
                mPGSCardUsed:{},
                cardDetails: {
                    card_cc: '',
                    card_exp: '',
                    card_cvv: '',
                    card_pin: '',
                }
            });

            this.$store.dispatch('isFailed', false);

            delete window.raw;

            if (isIframe) {
                window.parent.postMessage('close', referrer.includes("file://") ? "*" : referrer);

                if (this.$route.name !== 'mtn-popup-v2')
                    this.$router.push('/v2/mtn/popup').catch(err => {});

                // this.$destroy();
                this.in_view = '';
            } else
                console.warn("Oops.. Payment Popup can only close when triggered from an iframe");

        },

        continueToMerchant(data) {

            
            this.changeComponent('PaymentOptions');

            var raw = JSON.parse(window.raw)
            
            delete (raw.data.client_info ? raw.data.client_info : raw.client_info);
            delete (raw.data.paymentoptions ? raw.data.paymentoptions : raw.paymentoptions);

            let dataResponse = data.data || raw.data,
                referrer = this.$store.state.popupReferrer;

            delete dataResponse.client_info;
            delete data.client_info;


            let response = {
                status: data.status,
                message: data.message,
                data: dataResponse,
                amount: this.$store.state.payload.transaction.amount || 0,
                paymentmethod: this.$store.state.paymentMethod || null,
                reference: this.$store.state.transRef || null,
                optionsTransRef: this.$store.state.optionsTransRef || null,
            }

            if (this.$store.state.isFailed)
                response.parentTransRef = this.$store.state.parentTransRef

            this.$store.replaceState({
                paymentMethod: '',
                paymentMethodIndex: '',
                client_info: {},
                payload: {},
                service_call_payload: {},
                options: {},
                api_key: null,
                isFailed: false,
                hasPaid: false,
                hasOtp: false,
                isLoading: true,
                channels: {},
                popupReferrer: null,
                provider: {},
                card_cc: '',
                card_exp: '',
                card_cvv: '',
                parentTransRef: '',
                optionsTransRef: '',
                showDefaultView: false,
                transRef: '',
                mPGSCardUsed: {},
                cardDetails: {
                    card_cc: '',
                    card_exp: '',
                    card_cvv: '',
                    card_pin: '',
                }
            });

            delete window.raw;

            if (this.$route.name !== 'mtn-popup-v2') {
                this.$router.push('/v2/mtn/popup').catch(err => {});
            }
            this.in_view = '';
            window.parent.postMessage(JSON.stringify(response), referrer.includes("file://") ? "*" : referrer);
        },

        hasAutoClose(auth_type, status) {
            try {

                let initialPayload = this.getInitialPayload();
                if (Object.keys(initialPayload.transaction).includes('options') && initialPayload.transaction.options != null) {
                    let options = initialPayload.transaction.options;
                    if (Object.keys(options).length <= 0 || !Object.keys(options).includes('close_popup')) {
                        return {
                            status: false,
                            message: 'No Close Popup in options',
                            timeout: 0,
                        }
                    }
                    let close_popup = initialPayload.transaction.options.close_popup,
                        timeout = close_popup.timeout || 3, // 3 seconds by default
                        statuses = close_popup.status, // Pick status from initial payload
                        statusArray = [];

                    if (statuses == "undefined" && timeout == "undefined") {// Status was not set from initial paylaod
                        return {
                            status: false,
                            message: 'Status & timeout were not set from initial paylaod',
                            timeout: 0,
                        }
                    }

                    switch (status.toLowerCase()) {
                        case "successful":
                        case "success":
                            // statusArray = statuses.Successful
                            statusArray = statuses.Successful
                            break;

                        case "failed":
                            statusArray = statuses.Failed
                            break;

                        case "pendingfulfillment":
                            statusArray = statuses.PendingFulfillment
                            break;

                        case "optionsdelivered":
                            statusArray = statuses.OptionsDelivered
                            break;
                    }

                    // Check if auth_type is present in statusArray
                    // console.log(statusArray);
                    if (statusArray === "undefined") { // UNable to pick a status match
                        return {
                            status: false,
                            timeout: 0,
                        }
                    }

                    return (statusArray.length > 0 && statusArray.indexOf(auth_type) > -1) ?{status: true,timeout} : { status: false, timeout: 0}
                } else // Options is present
                    return {
                        status: false,
                        timeout: 0,
                    }
            } catch (err) {
                console.log(err)
            }
        },

        hasDefaultView() {
            try {

                let initialPayload = this.getInitialPayload();

                // if (initialPayload.transaction.options != null && (initialPayload.transaction.options.default_view && initialPayload.transaction.options.default_view != null)) {
                if (initialPayload.transaction.options != null && Object.keys(initialPayload.transaction.options).includes('default_view')) {
                    let default_view = initialPayload.transaction.options.default_view,
                        option = default_view.option.toLowerCase(),
                        provider = default_view.provider.toLowerCase();

                    if (this.paymentChannels != null) {
                        let isExist = this.paymentChannels.filter((item, index) => {

                            if (option === item.auth_type.toLowerCase()) { // Check if specified auth_type is present in the Options Response, now check when Options returns multiple auth types
                                item['key'] = index;

                                if (item.action.length > 0) { // check if specified provider is present in the list of providers for this auth type.
                                    // Loop through to know if Provideris present
                                    // let providerIsPresent = item.action.map((opt, key) => {
                                    let providerIsPresent = item.action.filter((opt, key) => {
                                        /* if(opt.provider.toLowerCase() == 'comingsoon'){
                                            item['provider_key'] = key;
                                            item['provider'] = opt.provider.toLowerCase();
                                            return opt;
                                        }else  */
                                        if (opt.provider.toLowerCase() == provider) {
                                            item['provider_key'] = key;
                                            item['provider'] = opt.provider.toLowerCase();
                                            return opt;
                                        }
                                    });

                                    // if(providerIsPresent.length <= 0){
                                    if (!providerIsPresent) {
                                        window.failedFromStart = true;
                                        window.failedFromDefaultView = true;
                                        let raw = JSON.parse(window.raw);
                                        raw.message = `${provider} provider is not present in the payment option.`;
                                        window.raw = JSON.stringify(raw);
                                        this.$router.push('/v2/mtn/warning').catch(() => {});
                                        return;
                                    }
                                } else { // Should I
                                    window.failedFromStart = true;
                                    window.failedFromDefaultView = true;
                                    let raw = JSON.parse(window.raw);
                                    raw.message = "The default provider you set is not available/enabled. Please contact your admin.";
                                    window.raw = JSON.stringify(raw);
                                    this.$router.push('/v2/mtn/warning').catch(() => {});
                                    return;
                                }

                                return {
                                    item,
                                }
                            }

                        });

                        // console.log(provider);

                        if (isExist.length > 0) {
                            // console.log(isExist);
                            this.$store.dispatch('showDefaultView', false);
                            return {
                                status: true,
                                auth_type: isExist[0].auth_type,
                                key: isExist[0].key,
                                provider_key: isExist[0].provider_key,
                            };
                        }
                    }
                    return {
                        status: false,
                    };
                } else
                    return {
                        status: false,
                    }
            } catch (err) {
                console.log(err)
            }
        },

        preferredPaymentOptions(payment_options, default_options) {
            // console.log(default_options);
            try {
                const dt = default_options.filter((item, index) => {
                    let prefferedOptionsKey = Object.keys(payment_options);

                    /**
                     ** Get the Preferred options key
                     ** Filter the options sent from the server against the preferred option
                     ** Filter the providers for each options again the preffered option of the current array index
                     **/

                    if (prefferedOptionsKey.includes(item.auth_type.toLowerCase())) { // Filter the payment options Eg card, custom,
                        if (item.action && item.auth_type.toLowerCase() != "card") { // Skip this for Card payment options such as card, mpgs
                            let keyIndex = prefferedOptionsKey.indexOf(item.auth_type.toLowerCase()); // Get array index of current auth type
                            // console.log(keyIndex);
                            let keyIndexProviderArray = Object.values(payment_options)[keyIndex].map(y => y.toLowerCase()); // Get provider array using the auth_type key index
                            item.action = item.action.filter((elem, idx) => elem.provider && (keyIndexProviderArray.includes(elem.provider.toLowerCase()) || elem.provider.toLowerCase() == "comingsoon"));
                            /* { // Filter auth_type action by provider and return providers that match
                                
                                if(elem.provider){
                                    console.log(`${elem.provider} Provider is not null`)
                                    return keyIndexProviderArray.includes(elem.provider); //&& elem.option !== "null";
                                }else{
                                    console.log(`${elem.provider} Provider is null`)
                                }
                                    // return keyIndexProviderArray.includes(elem.provider.toLowerCase()); //&& elem.option !== "null";
                            }); */

                            // if(item.action)
                            // return item.action.length> 0;
                        } else { // Only Card, mpgs options

                        }

                        // console.log(item);
                        return item;

                    }
                }).filter( (x) => x !== undefined &&  x.auth_type.toLowerCase() === 'card' || ((x   .action && x.action !== null) && x.action.length > 0));
                return dt;
            } catch (err) {
                console.log("[Preferred Payment Options Error]:" + err);
            }
        },

    },

};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity .7s;
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active in <2.1.8 */
    {
    opacity: 0;
}

.mpgs-card-top {
    top: 2% !important;
}

.show {
    display: block !important;
}

.text-center {
    text-align: center !important;
}

.mt-5,
.my-5 {
    margin-top: 3rem !important
}

.mb-5,
.my-5 {
    margin-bottom: 3rem !important
}

.mt-3,
.my-3 {
    margin-top: 1rem !important
}

.mb-3,
.my-3 {
    margin-bottom: 1rem !important
}

.m-3 {
    margin: 1rem !important
}

.mt-35,
.my-35 {
    margin-top: 1.5rem !important
}

.mb-35,
.my-35 {
    margin-bottom: 1.5rem !important
}

.m-35 {
    margin: 1.5rem !important
}

.mt-4,
.my-4 {
    margin-top: 1.7rem !important
}

.mb-4,
.my-4 {
    margin-bottom: 1.7rem !important
}

.m-4 {
    margin: 1.7rem !important
}

.mb-0,
.my-0 {
    margin-bottom: 0 !important
}

.pr-0,
.px-0 {
    padding-right: 0 !important
}

.pl-0,
.px-0 {
    padding-left: 0 !important
}

.pt-0,
.py-0 {
    padding-top: 0 !important
}

.pb-0,
.py-0 {
    padding-bottom: 0 !important
}
</style>
